import React from 'react';

const VIZ_TYPE_LABELS: Record<string, string> = {
  line_bar_graph: 'Line + Bar Chart',
  bar_chart: 'Bar Chart',
  line_chart: 'Line Chart',
  kpi_card: 'KPI Card',
  pie_donut: 'Pie / Donut',
  table: 'Table',
  no_data: 'No Data'
};

type VizTypeBadgeProps = {
  vizType: string;
};

export function VizTypeBadge({ vizType }: VizTypeBadgeProps) {
  const label = VIZ_TYPE_LABELS[vizType] ?? vizType;

  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-2.5 py-0.5 text-xs mt-[6px] font-medium text-primary">
      <svg
        className="h-3 w-3"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
      </svg>
      {label}
    </span>
  );
}
